<template>
  <popover-right v-model="isShowDetail" width='850px' class="firm-member-show" :closed="cancel" :completeClose="cancel">
    <div class="config-header">
      <h1 class="title-lable">消息通知配置</h1>  
      <p class="title-desc">说明：好房云支持多种方式推送，为减少重复消息对用户的打扰，可为不同角色设置短信推送的消息类型。</p>
    </div>
    <el-table :data="role_list" class="role-config-table" border>
      <el-table-column label="通知类型" width="130">
        <p slot-scope="scope" class="center">{{scope.row.title}}</p>
      </el-table-column>
      <el-table-column label="通知详情">
        <p slot-scope="scope" class="left">{{scope.row.desc}}</p>
      </el-table-column>
      <el-table-column label="短信通知" width="100">
        <p slot-scope="scope" class="center">
          <el-switch v-model="scope.row.status" :active-value="1" :inactive-value="2" @change="change(scope.row)"></el-switch>
        </p>
      </el-table-column>
    </el-table>
  </popover-right>
</template>
<script>
import PopoverRight from '@/components/popover/index';
import {getRoleSmsList, setRoleSmsList} from '@/api/firm';
export default{
  name: 'ConfigRole',
  components: {
    PopoverRight
  },
  data () {
    return {
      isShowDetail: false,
      role_list: []
    }
  },
  methods: {
    cancel () {
      this.isShowDetail = false;
      this.role_list = [];
    },
    open (id) {
      this.role_id = id;
      this.isShowDetail = true;
      this.initList();
    },
    async initList () {
      try {
        const res = await getRoleSmsList({
          role_id: this.role_id
        });
        this.role_list = res;
      } catch (err) {
        this.$message.error()
      }
    },
    async change (data) {
      try {
        await setRoleSmsList({
          ...data,
          role_id: this.role_id
        });
        this.$message.success('操作成功');
      } catch (err) {
        this.$message.error()
      }
    }
  }
}
</script>
<style lang="less" scoped>
.config-header{
  background: #f1f6fe;
  padding: 20px;
  .title-lable{
    color: #333;
    font-size: 17px;
  }
  .title-desc{
    background: #f1f6fe;
    color: #999;
    font-size: 12px;
    margin-top: 10px;
  }
}
.role-config-table{
  margin: 20px;
  width: calc(100% - 40px);
}
.center{
  text-align: center;
}
.left{
  padding-left: 20px;
}
</style>
<style lang="less">
.role-config-table{
  .el-table__header .el-table__cell{
    text-align: center;
    background: #EEF5FF;
  }
}
</style>